<div class="modal-header">
  <h4 class="modal-title">Gift PDF Preview</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body text-center">

  <div class="text-center d-inline-block" style="max-width: 400px">
  <img [src]="getLogoImage()"
       alt="logo"
       width="80" height="80"
       class="position-relative"
       style="border: 2px solid black; z-index: 2; background: white;">
  <br>
  <img [src]="bannerImageOption.image"
       width="300" height="150"
       class="position-relative"
       style="margin-top: -40px; z-index: 1;">

    <h3 style="margin-top: 30px">
      James Anderson has given you a gift, a 20 Entry Pass at {{ accountService.getMyAccount().organization_name }}
    </h3>

    <p class="lead text-left"
       style="line-height: 1.5rem; margin-top: 30px;">
      Happy birthday, Alex! Hope this year is one for the books and looking forward to many climbing sessions at the gym.
    </p>

    <p class="text-left mb-2"
       style="line-height: 1rem;">
      Redemption Code: 2UY93QLWHR
      <br>
      Must be redeemed by September 28, 2026
    </p>

    <p class="text-left mb-2"
       style="line-height: 1rem;">
      Redeem at
      <span class="text-nowrap">
        {{ orgConfig.climber_app_base_url }}gift/redeem/
      </span>
    </p>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
